// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1gQe4","info":"PatientInfo_info__2QudB"};